export class Message {
  public date = +new Date();
  public text: string;
  public type: MessageType;
  public code: string | undefined;

  constructor(text: string, type: MessageType, code?: string) {
    this.text = text;
    this.type = type;
    this.code = code;
  }
}

export enum MessageType {
  Success = 1,
  Warning,
  Error,
}
